export default {
  setTimezones (state, payload) {
    state.timezones = []
    state.timezones = payload
  },
  setAssetKinds (state, payload) {
    state.assetKinds = []
    state.assetKinds = payload
  }
}